// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-calendar[data-v-cad96d62]{width:100%;display:flex;flex-direction:column;flex:1}.calendar-grid[data-v-cad96d62]{background-color:#fff}.block[data-v-cad96d62]{min-height:500px}@media(min-width: 992px){.event-calendar[data-v-cad96d62]{width:100%;padding:5rem 0;background:#f3f3f3}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
